import React from 'react';
import { NavLink, useParams } from 'react-router-dom';
import queryString from 'query-string';
import { joinReact } from 'helpers/format';
import styles from './FolderBreadcrumbs.module.scss';
import { getFinalBreadcrumb, getBreadcrumb, GetName } from 'screens/FolderScreen/utils';

export const FolderBreadcrumbs = () => {
  const { folderId } = useParams();

  let links: any = [
    {
      label: 'Home',
      to: '/',
    },
  ];

  const params = queryString.parse(window.location.href.split(folderId as string)[1], {
    arrayFormat: 'comma',
  });

  const hasMultipleBreadcrumbs = typeof params.bc === 'object';
  const hasOneBreadcrumb = typeof params.bc === 'string';

  if (hasMultipleBreadcrumbs) {
    var array: any = params.bc;
    var arrayLength: any = params.bc!.length;
    for (var i = 0; i < arrayLength; i++) {
      links.push({
        label: <GetName nodeId={array[i]} />,
        to: getBreadcrumb(array, i, folderId),
      });
    }
    links.push({
      label: <GetName nodeId={folderId} />,
      to: getFinalBreadcrumb(array, arrayLength, folderId),
    });
  } else if (hasOneBreadcrumb) {
    links.push(
      {
        label: <GetName nodeId={params.bc} />,
        to: '/folder/' + params.bc,
      },
      {
        label: <GetName nodeId={folderId} />,
        to: '/folder/' + folderId + '?bc=' + params.bc,
      }
    );
  } else {
    links.push({
      label: <GetName nodeId={folderId} />,
      to: '/folder/' + folderId,
    });
  }

  const linkSymbol = ' / ';

  return (
    <div className={styles.container}>
      {joinReact(
        links.map((link: any, index: any) => {
          const { label, ...props } = link;
          if (props.to) {
            return (
              <NavLink key={index} className={styles.link} {...props}>
                {label}
              </NavLink>
            );
          } else {
            return (
              <NavLink key={index} className={styles.link} {...props}>
                {label}
              </NavLink>
            );
          }
        }),
        linkSymbol
      )}
    </div>
  );
};
